export function sleep(minTimeInMs: number, maxTimeInMs: number) {
  return new Promise((resolve, reject) => {
    if (minTimeInMs < 0 || maxTimeInMs < minTimeInMs) {
      reject(new Error('Invalid min or max time values.'))
    }
    const sleepTime = minTimeInMs + Math.ceil(Math.random() * (maxTimeInMs - minTimeInMs))
    setTimeout(resolve, sleepTime)
  })
}
